import React, {useCallback, useEffect, useMemo, useState} from "react"
import {useTranslation} from "react-i18next"
import {Dialog, DialogContent, IconButton, Typography, useMediaQuery} from "@material-ui/core"
import MuiDialogTitle from "@material-ui/core/DialogTitle"
import CloseIcon from "@material-ui/icons/Close"
import {useDispatch, useStore} from "../Store"
import "../i18n"
import TrendChart from "./TrendChart"
import SimilarBarChart from "./SimilarBarChart"
import {makeStyles} from "@material-ui/core/styles"
import clsx from "clsx"
import {useTheme} from "../hooks"

const useStyles = makeStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: `absolute`,
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  grid: {
    display: (props) => (props.mobile ? `block` : `grid`),
    gridTemplateColumns: `1fr 500px`,
    margin: `0px 8px`,
  },
}))

export default function TrendDialog() {
  const {t} = useTranslation()
  const {
    store: {themeColor, trendPanel, locale},
  } = useStore()
  const theme = useTheme(themeColor)
  const mobile = useMediaQuery(theme.breakpoints.down(`xs`))
  const classes = useStyles({mobile})
  const {dispatch} = useDispatch()
  const [closing, setClosing] = useState(false)

  const DialogTitle = ({title = null, classes = null, className = null, onClose = null}) => {
    return (
      <MuiDialogTitle disableTypography className={clsx(classes.root, className)}>
        <Typography align={`center`} variant="h5">
          {title}
        </Typography>
        {onClose ? (
          <IconButton className={classes.closeButton} onClick={onClose}>
            <CloseIcon />
          </IconButton>
        ) : null}
      </MuiDialogTitle>
    )
  }

  const handleClose = useCallback(() => {
    setClosing(true)
    setTimeout(() => {
      dispatch({
        type: `TREND_PANEL`,
        trendPanel: false,
      })
    }, 100)
  }, [])
  useEffect(() => {
    setClosing(false)
  }, [trendPanel])

  return useMemo(
    () => (
      <>
        <Dialog fullScreen={mobile} fullWidth maxWidth={`xl`} open={trendPanel} onClose={handleClose}>
          <DialogTitle classes={classes} title={t(`trendChart`)} onClose={handleClose} />
          <DialogContent>
            <div className={classes.grid}>
              <div className={`trendChart`}>
                <TrendChart closing={closing} />
              </div>
              <div className={`barChart`}>
                <SimilarBarChart id={`barChart`} closing={closing} />
              </div>
            </div>
          </DialogContent>
        </Dialog>
      </>
    ),
    [trendPanel, closing, classes, locale],
  )
}
